import { ApproveScheduleRequestAction, scheduleTemplateModalActions } from '../actions';
import api from '../../../../../../../../../services/api';
import { put } from 'redux-saga/effects';
import MODAL_MODE from '../../../../../../../common/constants';
import { scheduleActions } from '../../../../../redux-saga/actions';

export function* approveSchedule(action: ApproveScheduleRequestAction) {
  const { payload } = action;
  try {
    const res = yield api.post(
      `/v1/schedule-template/booking/${payload.scheduleTemplateID}/approve`,
      { UserIDs: payload.userIDs },
    );
    yield put(scheduleActions.reFetchAllEntries());
    yield put(
      scheduleTemplateModalActions.setScheduleTemplateModalMode({
        mode: MODAL_MODE.create,
        open: false,
      }),
    );
  } catch (err) {
    console.error('approve/reject schedule err', err);
  }
}
